<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HqcRou/tc-custom/9781426874178.jpg?1705766123550" alt="This image is the cover for the book House Calls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">House Calls
      </h1>
      <p class="bookDescription body article font2">
        <p>Sharing the cottage was her idea, and since Dr. Pete Morgan was <i>her</i> patient, Maggie made the rules. If only "Doc" weren't so attractive...and so hard to tame. She tried to convince him that the lake setting would heal him, body and soul. And her therapy seemed to be working...except with the demons he faced at night. Sometimes the only way to soothe him back to sleep was to slip beneath his sheets.<br/><br/>Maggie Holm knew she'd entered forbidden territory. She'd grown dangerously contented "playing house" with Pete, when she feared their affair was simply a summer distraction.<br/><br/>Because the summer <i>would</i> end.<br/><br/>Her feelings never would.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michelle Celmer
      </h2>
      
      <p class="authorDescription body article"><I>USA Today Bestseller</I> Michelle Celmer is the author of more than 40 books for Harlequin and Silhouette. You can usually find her in her office with her laptop loving the fact that she gets to work in her pajamas.<Br><Br>Michelle loves to hear from her readers! &#160;Visit Michelle on Facebook at Michelle Celmer Author, &#160;or email at michelle@michellecelmer.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?450c417a